
import React from 'react';
import CategoryBadge from '@/components/ui/CategoryBadge';
import { categories } from '@/data/articles';
import { useNavigate } from 'react-router-dom';

const CategorySection: React.FC = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId: string) => {
    navigate(`/achievers?category=${categoryId}`);
  };

  return (
    <section className="py-8 px-4 md:px-6 bg-secondary/50 border-y border-border/50">
      <div className="container mx-auto">
        <div className="flex flex-wrap gap-3 justify-center">
          {categories.map(category => (
            <div 
              key={category.id} 
              onClick={() => handleCategoryClick(category.id)}
              className="transition-transform hover:scale-105 cursor-pointer"
            >
              <CategoryBadge 
                categoryId={category.id} 
                size="lg" 
                className="shadow-sm" 
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
